import React, { useState } from "react";
import { Button, ButtonGroup, Box } from "@mui/material";
import SummaryCard from "../components/SummaryCard";
import OrdersGrid from "../components/OrdersGrid";
import ChartPanel from "../components/ChartPanel";
import Footer from "../components/Footer";

export default function Dashboard() {
  // ✅ One common state for all components
  const [period, setPeriod] = useState("Today");

  return (
    <>
      <div className="home-header">
        <h1 className="gradient-text animate-pulse">🏠 Summary</h1>
        <p className="welcome-text slide-in-up">
          Welcome back! Here's what's happening today
        </p>
      </div>

      {/* Common Tabs */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <ButtonGroup variant="contained">
          {["Today", "Weekly", "Monthly"].map((tab) => (
            <Button
              key={tab}
              color={period === tab ? "error" : "primary"}
              onClick={() => setPeriod(tab)}
            >
              {tab}
            </Button>
          ))}
        </ButtonGroup>
      </Box>

      {/* Pass the same period to all children */}
      <SummaryCard period={period} />
       <div className="stats-grid">
        <div className="stat-card">
         <OrdersGrid period={period} />
        </div>
        <div className="stat-card">
          <ChartPanel period={period} />
        </div>
       </div>
      
      

      <Footer />
    </>
  );
}